import { HelperDrawerSectionEnum } from './types';

export const HEADER_TEXT = {
  [HelperDrawerSectionEnum.GLOBAL]:
    'Our staff is available to help with any question you may have with using our website or any topic around managing your Vacation Rental. Please do not hesitate to contact us if you have any questions or need assistance.',
  [HelperDrawerSectionEnum.ONBOARDING]:
    'Our staff is available to help you through the setup process. Please do not hesitate to contact us if have any questions or need assistance.',
};

const CONTACT_PREFIX = {
  email: 'mailto:',
  telephone: 'tel:',
};

interface Args {
  contactType: string;
  contactDetail: string;
}

export const contactHref = ({ contactType, contactDetail }: Args) =>
  CONTACT_PREFIX[contactType as keyof typeof CONTACT_PREFIX] + contactDetail;
